import { Pipe, PipeTransform } from '@angular/core';
import { LayoutService, DetectDeviceService } from '@apps/ui';

@Pipe({
  name: 'rwdImage'
})
export class RwdImagePipe implements PipeTransform {
  constructor(
    private layout: LayoutService,
    private device: DetectDeviceService
  ) {}

  public transform(
    img: string,
    sizes: string[],
    breakpoints?: string[],
    nexgen: boolean = true
  ): string {
    if (!img || !sizes || !sizes.length) {
      return;
    }

    let sufix = '';
    if (sizes.length === 1) {
      sufix = sizes[0];
    } else if (breakpoints && breakpoints.length) {
      const breakpoint = this.layout.widthSubject.getValue();
      const index = breakpoints.indexOf(breakpoint);
      if (index > sizes.length || index === -1) {
        sufix = sizes[sizes.length - 1];
      } else {
        sufix = sizes[index];
      }
    }

    const url = this.getFileName(img);
    const ext = nexgen ? this.getNextGenExtension() : this.getFileExtension(img);
    return `${url}${sufix ? '_' + sufix : ''}.${ext}`;
  }

  private getFileName(filename): string {
    return filename
      .split('.')
      .slice(0, -1)
      .join('.');
  }

  private getFileExtension(filename): string {
    return filename.split('.').pop();
  }

  private getNextGenExtension(): string {
    if (this.device.isiOS || this.device.isSafari) {
      return 'jp2';
    } else {
      return 'webp';
    }
  }
}
